import React from "react";

const CategoriesDepenses = () => {
  return (
    <div className="categories-depenses">
      <h2>Catégories de dépenses</h2>
      <p>Gestion des catégories de dépenses.</p>
    </div>
  );
};

export default CategoriesDepenses;
